var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    class: _vm.attachClass,
    staticStyle: {
      "position": "relative"
    }
  }, [_c('v-menu', {
    ref: "menu",
    attrs: {
      "close-on-content-click": false,
      "return-value": _vm.date,
      "transition": "scale-transition",
      "min-width": "290px",
      "max-width": "290px",
      "offset-y": "",
      "attach": _vm.attach ? `.${_vm.attachClass}` : false
    },
    on: {
      "update:returnValue": function ($event) {
        _vm.date = $event;
      },
      "update:return-value": function ($event) {
        _vm.date = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on;
        return [_c('v-text-field', _vm._g(_vm._b({
          staticClass: "pt-0",
          class: _vm.textFieldClass,
          attrs: {
            "value": _vm.formatData,
            "append-icon": "event",
            "readonly": ""
          },
          on: {
            "click:append": on.click
          }
        }, 'v-text-field', _vm.$attrs, false), on))];
      }
    }])
  }, [_c('v-date-picker', {
    attrs: {
      "type": "date",
      "max": "2999-12-31",
      "no-title": "",
      "scrollable": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$refs.menu.save(_vm.date);
      }
    },
    model: {
      value: _vm.date,
      callback: function ($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }